import React, { useEffect, useState } from 'react';
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from '@mui/material/Grid';
import * as dates from '@simplybenefits/sb-dates';
import Modal from './Modal.js';
import Text from '../Text.js';
import DateInput from '../../components/TextFields/DateInput.js';
import InfoTip from '../InfoTip.js';
import Bubble from '../Bubble.js';
import i18n from '../../localization/i18n';
import tokens from '../../localization/tokens.js';
import { validateInput } from '../../services/index.js';
const initialState = {
  startDate: '',
  endDate: '',
  acceptedTerms: false
};
const initialErrorState = {
  startDateError: false,
  endDateError: false,
  acceptedTermsError: false
};

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ReinstateCoverageModal = ({
  open,
  close,
  openChangeRequestModal,
  meta
}) => {
  const [reinstateFor, setReinstateFor] = useState(false);
  const [hasWaivedBenefits, setHasWaivedBenefits] = useState(false);
  const [comparableCoverage, setComparableCoverage] = useState(initialState);
  const [errorState, setErrorState] = useState(initialErrorState);
  const {
    startDateError,
    endDateError,
    acceptedTermsError
  } = errorState;
  const {
    startDate,
    endDate,
    acceptedTerms
  } = comparableCoverage;
  useEffect(() => {
    if (!reinstateFor) {
      setHasWaivedBenefits(false);
    }
  }, [reinstateFor]);
  useEffect(() => {
    setReinstateFor(false);
    setHasWaivedBenefits(false);
    setErrorState(initialErrorState);
  }, []);

  /**
   * 
   * @param {*} field 
   * @param {*} value 
   */
  const handleInputChange = (field, value) => {
    setComparableCoverage(prevState => ({
      ...prevState,
      [field]: value
    }));
  };

  /**
   * 
   */
  const resetForm = () => {
    setReinstateFor(false);
    setHasWaivedBenefits(false);
    setErrorState(initialErrorState);
    setComparableCoverage(initialState);
  };

  /**
   * 
   * @returns 
   */
  const validateFormAndOpenChangeRequest = async () => {
    let errors = {};
    errors.startDateError = startDate ? await validateInput('date', startDate, i18n.locale) : false;
    errors.endDateError = startDate || endDate ? await validateInput('date', endDate, i18n.locale) : false;
    errors.acceptedTermsError = !acceptedTerms;

    // Check for any errors
    const hasErrors = Object.values(errors).some(Boolean);
    if (hasErrors) {
      setErrorState({
        ...errors
      });
      return false;
    }
    const changeRequestData = {
      type: 'Reinstate Benefits',
      details: {
        reinstateFor,
        hasWaived: hasWaivedBenefits,
        startDate: startDate ? dates.getUTC(startDate) : null,
        endDate: endDate ? dates.getUTC(endDate) : null
      }
    };
    openChangeRequestModal(changeRequestData);

    // reset form on creation of change request
    resetForm();
    return true;
  };

  /**
   * 
   */
  const onClose = () => {
    resetForm();
    close();
  };

  /**
   * 
   * @returns 
   */
  const WaiveForBubbles = () => /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      // Set the spacing between the items
      width: '65%',
      height: 50
    }
  }, meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.signup.myselfAndDependents),
    isSelected: reinstateFor === 'Self-Dependents',
    onClick: () => reinstateFor !== "Self-Dependents" ? setReinstateFor("Self-Dependents") : setReinstateFor(false)
  }) : null, meta.waiveFor === 'Dependents' || meta.waiveFor === 'Self-Dependents' ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.signup.dependentsOnly),
    isSelected: reinstateFor === 'Dependents',
    onClick: () => reinstateFor !== "Dependents" ? setReinstateFor("Dependents") : setReinstateFor(false)
  }) : null);

  /**
   * 
   * @returns 
   */
  const WaivedBenefitsBubbles = () => /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      // Set the spacing between the items
      width: '85%',
      height: 50
    }
  }, meta.hasWaived === 'Health' || meta.hasWaived === 'Health-Dental' ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.changeRequests.extendedHealth),
    isSelected: hasWaivedBenefits === 'Health',
    onClick: () => hasWaivedBenefits !== 'Health' ? setHasWaivedBenefits("Health") : setHasWaivedBenefits(false),
    rightIcon: /*#__PURE__*/React.createElement(InfoTip, {
      active: hasWaivedBenefits === 'Health'
    }),
    onClickRightIcon: () => null
  }) : null, meta.hasWaived === 'Dental' || meta.hasWaived === 'Health-Dental' ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.titles.dental),
    isSelected: hasWaivedBenefits === 'Dental',
    onClick: () => hasWaivedBenefits !== 'Dental' ? setHasWaivedBenefits('Dental') : setHasWaivedBenefits(false)
  }) : null, meta.hasWaived === 'Health-Dental' ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.changeRequests.extendedHealthCareDental),
    isSelected: hasWaivedBenefits === 'Health-Dental',
    onClick: () => hasWaivedBenefits !== 'Health-Dental' ? setHasWaivedBenefits('Health-Dental') : setHasWaivedBenefits(false)
  }) : null);
  return /*#__PURE__*/React.createElement(Modal, {
    medium: true,
    open: open,
    onClose: onClose,
    title: i18n.t(tokens.labels.changeRequests.reinstateCoverage),
    primaryButton: {
      label: i18n.t(tokens.labels.changeRequests.reinstateCoverage),
      onClick: validateFormAndOpenChangeRequest
    }
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true
  }, i18n.t(tokens.labels.changeRequests.youHaveWaivedCoverage)), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true,
    margin: "20px 0 10px 0"
  }, i18n.t(tokens.labels.changeRequests.reinstatingCoverageFor)), /*#__PURE__*/React.createElement(WaiveForBubbles, null), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    small: true,
    margin: "20px 0 10px 0"
  }, i18n.t(tokens.labels.signup.forTheFollowingBenefits)), /*#__PURE__*/React.createElement(WaivedBenefitsBubbles, null), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    customStyle: {
      marginTop: 20,
      marginBottom: 10
    }
  }, i18n.t(tokens.labels.changeRequests.reinstatingDueTo)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.dateStart),
    value: startDate,
    onChange: e => handleInputChange('startDate', e.target.value),
    error: startDateError,
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.dateEnd),
    value: endDate,
    onChange: e => handleInputChange('endDate', e.target.value),
    error: endDateError,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: Boolean(acceptedTerms),
      onChange: () => handleInputChange('acceptedTerms', !acceptedTerms)
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      avMedium: true
    }, i18n.t(tokens.labels.changeRequests.confirmReinstateCoverage))
  })), acceptedTermsError ? /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, i18n.t(tokens.labels.banking.youMustAcceptTermsError)) : null));
};
export default ReinstateCoverageModal;